<tcc-mono-dialog-layout
  [title]="stable?.id ? 'Stal bewerken' : 'Stal toevoegen'"
  (onSave)="save()"
>
  <form [formGroup]="form">
    <ion-grid class="form-grid">
      <!-- Algemeen -->
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary"><h3 class="section-title">Algemeen</h3></ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ion-item
            lines="none"
            (click)="selectRelation()"
            [detail]="false"
            button
            class="picker-layout"
          >
            <ion-label position="stacked" class="form-label required">Bedrijf</ion-label>
            <ion-text color="primary" class="ion-padding">
              <tcc-mono-display-relation-property
                [relationId]="form.get('relation_id').value"
              ></tcc-mono-display-relation-property>
            </ion-text>
          </ion-item>
        </ion-col>
        <ion-col size="5" sizeMd="5">
          <ion-input
            type="text"
            mode="md"
            formControlName="name"
            labelPlacement="stacked"
            errorText="Naam is verplicht"
            fill="solid"
          >
            <ion-text slot="label" class="form-label required">Naam</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="7" sizeMd="7">
          <div class="ubn-with-fetch">
            <ion-input
              type="number"
              mode="md"
              formControlName="ubn"
              labelPlacement="stacked"
              class="ubn-input"
              [errorText]="
                form.get('ubn').hasError('pattern')
                  ? 'Alleen getallen toegestaan'
                  : form.get('ubn').hasError('max')
                  ? 'Te hoog'
                  : 'Ongeldige waarde'
              "
              fill="solid"
              inputmode="numeric"
              min="0"
              step="1"
            >
              <ion-text slot="label" class="form-label required">UBN</ion-text>
            </ion-input>
            <ion-button
              fill="outline"
              color="primary"
              class="ubn-fetch-button"
              [disabled]="!canFetchAddressFromUbn()"
              (click)="fetchAddressFromUbn()"
            >
              RVO adres ophalen
            </ion-button>
          </div>
        </ion-col>
        <ion-col size="12">
          <ion-textarea
            mode="md"
            formControlName="remarks"
            labelPlacement="stacked"
            fill="solid"
            rows="2"
            autoGrow="true"
          >
            <ion-text slot="label" class="form-label">Opmerkingen</ion-text>
          </ion-textarea>
        </ion-col>
      </ion-row>

      <!-- Adres -->
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary"><h3 class="section-title">Adres</h3></ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12">
          <ion-input
            type="text"
            mode="md"
            formControlName="address"
            labelPlacement="stacked"
            errorText="Adres is verplicht"
            fill="solid"
          >
            <ion-text slot="label" class="form-label required">Adres</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="4" sizeMd="4">
          <ion-input
            type="text"
            mode="md"
            formControlName="zipcode"
            labelPlacement="stacked"
            errorText="Postcode is verplicht"
            fill="solid"
          >
            <ion-text slot="label" class="form-label required">Postcode</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="8" sizeMd="8">
          <ion-input
            type="text"
            mode="md"
            formControlName="city"
            labelPlacement="stacked"
            errorText="Plaats is verplicht"
            fill="solid"
          >
            <ion-text slot="label" class="form-label required">Plaats</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="6" sizeMd="6">
          <ion-select
            mode="md"
            formControlName="country"
            labelPlacement="stacked"
            errorText="Land is verplicht"
            fill="solid"
            class="country-select-align"
          >
            <ion-text slot="label" class="form-label required">Land</ion-text>
            <ion-select-option *ngFor="let country of countryOptions" [value]="country.code">
              {{ country.code }} — {{ country.label }}
            </ion-select-option>
          </ion-select>
        </ion-col>
        <ion-col size="6" sizeMd="6">
          <ion-input
            type="text"
            mode="md"
            formControlName="phone"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label">Telefoon</ion-text>
          </ion-input>
        </ion-col>
      </ion-row>

      <ion-row
        *ngIf="stable.relation_visit_address || stable.relation_visit_zipcode || stable.relation_visit_city || stable.relation_visit_phone"
      >
        <ion-col size="12">
          <ion-item lines="none" class="info-block">
            <ion-label>
              <div class="address-header">
                <h3>Bezoekadres relatie</h3>
                <ion-button
                  fill="solid"
                  size="small"
                  color="primary"
                  (click)="copyVisitAddress()"
                  class="copy-button"
                >
                  <fa-icon [icon]="['fal', 'arrow-right']" slot="start"></fa-icon>
                  Overnemen
                </ion-button>
              </div>
              <div class="address-info">
                <div *ngIf="stable.relation_visit_address" class="address-line">
                  {{ stable.relation_visit_address }}
                </div>
                <div
                  *ngIf="stable.relation_visit_zipcode || stable.relation_visit_city"
                  class="address-line"
                >
                  {{ stable.relation_visit_zipcode }} {{ stable.relation_visit_city }}
                </div>
                <div *ngIf="stable.relation_visit_phone" class="address-line">
                  {{ stable.relation_visit_phone }}
                </div>
              </div>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>

      <!-- RVO & registratie -->
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary"><h3 class="section-title">RVO & registratie</h3></ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="8" sizeMd="8">
          <ion-input
            type="text"
            mode="md"
            formControlName="rvo_number"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label">RVO registratienummer</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="4" sizeMd="4">
          <ion-input
            type="number"
            mode="md"
            formControlName="skv_capacity"
            labelPlacement="stacked"
            fill="solid"
            inputmode="numeric"
            min="0"
            step="1"
          >
            <ion-text slot="label" class="form-label">SKV capaciteit</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="6" sizeMd="6">
          <ion-input
            type="text"
            mode="md"
            formControlName="rvo_user"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label">RVO gebruikersnaam</ion-text>
          </ion-input>
        </ion-col>
        <ion-col size="6" sizeMd="6">
          <ion-input
            type="text"
            mode="md"
            formControlName="rvo_password"
            labelPlacement="stacked"
            fill="solid"
          >
            <ion-text slot="label" class="form-label">RVO wachtwoord</ion-text>
          </ion-input>
        </ion-col>
      </ion-row>

      <!-- Opties -->
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary"><h3 class="section-title">Opties</h3></ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="6" sizeMd="3">
          <ion-item lines="none" [detail]="false" class="picker-layout">
            <ion-checkbox formControlName="rvo_eigenbeheer" labelPlacement="end">
              RVO eigenbeheer
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="6" sizeMd="3">
          <ion-item lines="none" [detail]="false" class="picker-layout">
            <ion-checkbox formControlName="is_gtskv_loadingplace" labelPlacement="end">
              GTSKV laadstal
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="6" sizeMd="3">
          <ion-item lines="none" [detail]="false" class="picker-layout">
            <ion-checkbox formControlName="weide_toeslag" labelPlacement="end">
              Weide toeslag
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="6" sizeMd="3">
          <ion-item lines="none" [detail]="false" class="picker-layout">
            <ion-checkbox formControlName="vitaal_kalf_participant" labelPlacement="end">
              Vitaal kalf
            </ion-checkbox>
          </ion-item>
        </ion-col>
      </ion-row>

      <!-- Koppel type instellingen -->
      <ion-row>
        <ion-col size="12">
          <ion-text color="primary"><h3 class="section-title">Koppel type instellingen</h3></ion-text>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="getAvailablePredefinedTypes().length > 0">
        <ion-col size="12">
          <div class="predefined-types-section">
            <span class="predefined-types-title">Voorgedefinieerde types:</span>
            <div class="predefined-types-buttons">
              <ion-button
                *ngFor="let type of getAvailablePredefinedTypes()"
                fill="outline"
                size="small"
                color="primary"
                (click)="addPredefinedKoppelType(type)"
                class="predefined-type-button"
              >
                {{ type.label }}
              </ion-button>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row formArrayName="koppel_type_settings">
        <ion-col
          size="12"
          *ngFor="let setting of koppelTypeSettingsArray.controls; let i = index"
          [formGroupName]="i"
        >
          <div class="koppel-setting-row">
            <div class="koppel-input-group">
              <ion-input
                type="text"
                mode="md"
                formControlName="key"
                labelPlacement="stacked"
                [errorText]="setting.get('key')?.hasError('required') ? 'Type is verplicht' : ''"
                fill="solid"
                placeholder="Type naam"
                [class.ion-invalid]="setting.get('key')?.invalid && setting.get('key')?.touched"
              >
                <ion-text slot="label" class="form-label required">Type</ion-text>
              </ion-input>
            </div>
            <div class="koppel-input-group">
              <ion-input
                type="number"
                mode="md"
                formControlName="value"
                labelPlacement="stacked"
                [errorText]="
                  setting.get('value')?.hasError('required')
                    ? 'Waarde is verplicht'
                    : setting.get('value')?.hasError('min')
                    ? 'Waarde moet 0 of hoger zijn'
                    : ''
                "
                fill="solid"
                inputmode="numeric"
                min="0"
                step="1"
                placeholder="0"
                [class.ion-invalid]="setting.get('value')?.invalid && setting.get('value')?.touched"
              >
                <ion-text slot="label" class="form-label required">Waarde</ion-text>
              </ion-input>
            </div>
            <div class="koppel-button-group">
              <ion-button
                fill="clear"
                color="danger"
                size="small"
                (click)="removeKoppelTypeSetting(i)"
                class="remove-button"
              >
                <fa-icon [icon]="['fal', 'trash']"></fa-icon>
              </ion-button>
            </div>
          </div>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12">
          <ion-button
            fill="outline"
            color="primary"
            size="small"
            (click)="addKoppelTypeSetting()"
            class="add-setting-button"
          >
            <fa-icon [icon]="['fal', 'plus']" slot="start"></fa-icon>
            Koppel type toevoegen
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</tcc-mono-dialog-layout>
